"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleRegistrationNumberValidation = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
class VehicleRegistrationNumberValidation extends journey_services_1.ValidationMethodBase {
    validateInput(input, context) {
        const pageContext = context;
        if (pageContext.engine && pageContext.engine.getJourneyState()) {
            const errorCode = pageContext.engine.getJourneyState().ocrErrorCode;
            pageContext.engine.getInteraction().underwritingResult = [];
            if (errorCode) {
                let errorMessage = "Sorry, we couldn't read your registration number. Please upload new photo.";
                switch (errorCode) {
                    case "serviceError":
                        errorMessage = "Failed to upload your photo.";
                        break;
                    case "3":
                        errorMessage = "Sorry, we couldn't read your registration number. Please upload new photo.";
                        break;
                    case "4":
                        errorMessage = "Sorry, we couldn't read your registration number. Please upload photo again.\nIt works best when only your car’s registration number is captured in your photo.";
                        break;
                }
                pageContext.engine.setJourneyState({ ocrErrorCode: null });
                return this.invalidResult(errorMessage);
            }
        }
        return this.validResult();
    }
}
exports.VehicleRegistrationNumberValidation = VehicleRegistrationNumberValidation;
//# sourceMappingURL=VehicleRegistrationNumberValidation.js.map